import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50" id="categorias">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-800 rounded-full text-xs font-semibold tracking-wide mb-4">
            CATEGORIAS
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Categorias de Produtos
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Explore todas as categorias disponíveis e encontre os melhores produtos
            para importar da China com o CSSBuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleClick(cat.url)}
              className="group relative bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer text-left"
            >
              {cat.isPopular && (
                <div className="absolute top-3 left-3 z-10 px-2 py-0.5 bg-primary-500 text-background-50 rounded-md text-[10px] font-bold tracking-wider">
                  POP
                </div>
              )}
              <div className="w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">Ver produtos →</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}